module.exports = "<div class=\"c-faq-list\">\n    <slot name=\"heading\"></slot>\n    <slot></slot>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/faq-list/faq-list.vhtml
// module id = 302
// module chunks = 0